import React from "react";
import PropTypes from "prop-types";
import DocumentService from "services/documents-service";

function initials(name) {
    if (!name) {
        return "?";
    }
    return name
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part[0].toUpperCase())
        .join("");
}

/**
 * Applicant identity avatar. Fetches the KYC photo through the auth-aware
 * DocumentService and shows it; falls back to initials when there's no photo or
 * it fails to load. Gives every applicant a face at a glance.
 */
class ApplicantAvatar extends React.Component {
    state = { src: null };

    componentDidMount() {
        if (this.hasPhoto()) {
            this.fetchPhoto(this.props.filePath);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.filePath !== this.props.filePath) {
            this.revoke();
            this.setState({ src: null }, () => {
                if (this.hasPhoto()) {
                    this.fetchPhoto(this.props.filePath);
                }
            });
        }
    }

    componentWillUnmount() {
        this.revoke();
    }

    hasPhoto() {
        return typeof this.props.filePath === "string" && this.props.filePath;
    }

    revoke() {
        if (this.state.src) {
            URL.revokeObjectURL(this.state.src);
        }
    }

    fetchPhoto(filePath) {
        DocumentService.getDocumentUrl(filePath)
            .then(({ data, headers }) => {
                const type = headers["content-type"] || "";
                if (type.includes("pdf")) {
                    return; // a PDF isn't a usable avatar
                }
                const blob = new Blob([data], { type });
                this.setState({ src: URL.createObjectURL(blob) });
            })
            .catch(() => {});
    }

    render() {
        const { name, size } = this.props;
        const dimension = size || 48;
        const style = { width: dimension, height: dimension, fontSize: dimension / 2.6 };
        return (
            <span className={"cc-avatar"} style={style}>
                {this.state.src ? (
                    <img
                        className={"cc-avatar__img"}
                        src={this.state.src}
                        alt={name || "applicant"}
                    />
                ) : (
                    <span className={"cc-avatar__initials"}>
                        {initials(name)}
                    </span>
                )}
            </span>
        );
    }
}

ApplicantAvatar.propTypes = {
    filePath: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.number
};

export default ApplicantAvatar;
